export const BAL_TYPE_SMARTCASH_SECURE = "SMARTCASH_SECURE";
export const SMARTCASH_SECURE_PAYMENT_BETA_CODE = "smartcashSecurePayment";
export const SMARTCASH_SECURE = "SMARTCASH_SECURE";
export const SMARTCASH = "SMARTCASH";
export const NOT_SMARTCASH_USER = "NOT_SMARTCASH_USER";
export const ENTER_SMARTCASH_PIN = "ENTER_SMARTCASH_PIN";
export const INVALID_SMARTCASH_PIN = "INVALID_SMARTCASH_PIN";
export const OTP_LIMIT_EXHAUSTED = "OTP_LIMIT_EXHAUSTED";
export const SMARTCASH_PIN_HEADER_TEXT = "SMARTCASH_PIN_HEADER_TEXT";
export const SOME_ERR = "SOME_ERR";
export const POWERED_BY = "POWERED_BY";
export const SMARTCASH_PLACE_HOLDER_TEXT = "SMARTCASH_PLACE_HOLDER_TEXT";

export const VERIFY_OTP_ERROR_CODES = {
  INVALID_OTP: 5047,
  OTP_EXPIRED: 5046,
  LIMIT_EXHAUSTED: 5048,
  DOWNSTREAM_ERROR: 5045,
  BAD_REQUEST: 5049,
  BLANK_OTP: 5050,
  BLANK_REF_TXN_ID: 5051
}

export const SEND_OTP_ERROR_CODES = {
  LIMIT_EXHAUSTED: 5029,
  BAD_REQUEST: 5030,
  IS_EMAIL_NULL: 5031,
  IS_SMS_NULL: 5032,
  IS_WHATSAPP_NULL: 5033,
  OTP_TEMPLATE_ID_BLANK: 5034,
  MESSAGE_SENT_FAILED: 5035,
  OTP_TEMPLATE_NOT_FOUND: 5036,
  EMAIL_ID_BLANK: 5037,
  MOBILE_NUMBER_BLANK: 5038,
  ERROR_FROM_DS: 5039
}

export const PROCESS_TXN_ERROR_CODES = {
  INVALID_MSISDN: 4174,
  TRANSACTION_NOT_ALLOWED: 5023,
  DOWNSTREAM_UNKNOWN_ERROR: 5022,
  INVALID_AMOUNT: 5021,
  INVALID_INPUT: 5020,
  BLANK_MOBILE_NUMBER: 5019,
  INVALID_PHONE_NUMBER: 5018,
  NULL_ENCRYPTION_KEY_ID: 5017,
  NULL_PAYER_ACCOUNT_TYPE: 5016,
  NULL_PAYER_ACCOUNT_ID: 5015,
  INCORRECT_PIN: 5014,
  INVALID_PIN: 4057,
  ACCOUNT_DETAILS_NOT_FOUND: 400,
  GENERIC_ERROR: 5052
};

export const VALIDATE_ACCOUNT_ERROR_CODES = {
  INVALID_MSISDN: 5013,
  CUSTOMER_NOT_FOUND: 5012,
  BAD_REQUEST: 400
}

export const RESEND_OTP_ERROR_CODES = {
  DOWNSTREAM_ERROR: 5040,
  OTP_LIMIT_EXHAUSTED: 5041,
  BAD_REQUEST: 5042,
  MESSAGE_SENT_FAILED: 5043,
  BLANK_REF_TXN_ID: 5044
}

export const SMARTCASH_EVENTS = {
  GUEST: "g_",
  BUY_BNDL: "buybndl_",
  BUY_AIRTIME: "buyairtime_",
  PAYMENT_SUCCESSFUL_: "paymentsuccessful_",
  PAYMENT_MODE_SELECTED_ANY: "paymentmodeselected_any",
  NUM_ENTERED: "pymtmod_sel_smartcash_num_entr",
  OTP_ENTERED_CORRECT: "smartcash_otp_correct",
  OTP_ENTERED_INCORRECT: "smartcash_otp_incorrect",
  OTP_ENTERED_INCORRECT_MAX: "smartcash_otp_incor_max",
  PIN_ENTERED: "smartcash_pin_entered",
  ANY_PAYMENT_MODE_SELECTED: "paymentmodeselected_any",
  PAYMENT_SUCCESSFUL: "payment_successful",
  PAYMENT_SUCCESSFUL_SMARTCASH: "paymentsuccessful_smartcash",
  PAYMENT_FAILED: "paymentfailed",
  PAYMENT_FAILED_SMARTCASH: "paymentfailed_smartcash",
  PAYMENT_SUCCESSFUL_SELF: "payment_successful_self",
  PAYMENT_SUCCESSFUL_OTHERS: "payment_successful_others",
  PAYMENT_FAILED_SMARTCASH_INCORRECT_PIN: "pymtfail_smartcash_incorpin",
  PAYMENT_FAILED_SMARTCASH_INSUFFICIENT_BALANCE: "pymtfail_smartcash_insuffbal",
  PAYMENT_FAILED_SMARTCASH_OTHERS: "paymentfail_smartcash_others",
  PAYMENT_MODE_SELECTED_SMARTCASH: "paymentmodeselected_smartcash",

  PROCEED_CLICKED: "smartcash_num_proceed_clicked",
  ENCRYPTION_KEY_FETCH_SUCCESS: "encryption_key_fetched_successfully",
  ENCRYPTION_KEY_FETCH_FAIL: "encryption_key_fetch_failed",
  SMARTCASH_ACCOUNT: "smartcash_acc_",
  VALIDATED_SUCCESSFULLY: "validated_successfully",
  INVALIDATED: "invalidated",
  OTP_SCREEN_VIEWED: "smartcash_otp_screen_viewed",
  OTP_RESEND_CLICKED: "smartcash_otp_resend_clicked",
  OTP_RESEND_FAIL: "smartcash_otp_resend_failed",
  OTP_RESEND_SUCCESS: "smartcash_otp_resend_success"
}

export const SMART_CASH_TXN_LIMIT_BETA_NAME="smartCashOtpTxnLimit"